import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Employee } from '@generated/models';
import { TagModule } from 'primeng/tag';
import { EmployeeLinkPipe } from '../pipes/employee-link.pipe';

@Component({
  selector: 'app-employee-code-tag',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TagModule, RouterModule, NgTemplateOutlet, EmployeeLinkPipe],
  template: `
    @let _size = size();
    @let _employee = employee();
    @let _clickable = clickable();

    @if (_clickable) {
      <a [routerLink]="_employee | employeeLink" (click)="onClick($event)">
        <ng-container [ngTemplateOutlet]="tag" />
      </a>
    } @else {
      <ng-container [ngTemplateOutlet]="tag" />
    }

    <ng-template #tag>
      @let _small = _size === 'small';
      <p-tag class="h-6 w-26">
        <div class="flex items-center gap-1 px-1.5 whitespace-nowrap">
          <i [class.!text-3xs]="_small" [class.!text-2xs]="!_small" class="pi pi-id-card"></i>
          <span [class]="_size === 'small' ? '!text-2xs' : '!text-sm'" class="font-bold">
            {{ _employee.code }}
          </span>
        </div>
      </p-tag>
    </ng-template>
  `,
  styles: [
    `
      .p-tag {
        border: 1px solid var(--color-soe-orchid-purple);
        box-shadow: 2px 1px 0px 0px var(--color-soe-orchid-purple);
        --p-tag-primary-background: var(--color-white);
        padding: 0;
        --p-tag-primary-color: var(--color-black);
      }
    `,
  ],
})
export class EmployeeCodeTagComponent {
  readonly size = input<'small' | 'default'>('default');
  readonly clickable = input<boolean>(true);
  readonly employee = input.required<Pick<Employee, 'id' | 'code'>>();

  onClick(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
  }
}
